// @flow
import React from 'react';
import { Mutation } from '@apollo/client/react/components';
import { toastError } from 'bench-internal-theme';

import ClientComments from './ClientComments';
import type { ClientComment } from './types';
import { CREATE_JOURNAL_ENTRY_CLIENT_COMMENT } from './queries';
// $FlowFixMe - TS file
import { getJournalEntries1099RefetchQuery } from '../bk-web-app/transaction-manager/components/transactions-1099-container/graphql';

const handleMutationError = error =>
  toastError(
    'Change Was Not Saved',
    `An error was encountered while trying to save. The error was: ${error.message}`,
  );

type ClientCommentsContainerProps = {
  clientComments: Array<ClientComment>,
  journalEntryId: string,
  clientId: string,
};

const ClientCommentsContainer = ({
  clientComments,
  journalEntryId,
  clientId,
}: ClientCommentsContainerProps) => {
  return (
    <Mutation
      mutation={CREATE_JOURNAL_ENTRY_CLIENT_COMMENT}
      refetchQueries={getJournalEntries1099RefetchQuery(clientId)}
      onError={handleMutationError}
    >
      {createMessage => (
        <ClientComments
          createMessage={body =>
            createMessage({
              variables: {
                parentId: journalEntryId,
                body,
                clientId,
              },
            })
          }
          clientComments={clientComments}
          journalEntryId={journalEntryId}
          clientId={clientId}
          placeholder="Leave a comment for your client"
        />
      )}
    </Mutation>
  );
};

export default ClientCommentsContainer;
